import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  SETTINGS_TOKEN,
} from '@app/Seller/accessTokens'

const SettingsBase = () => import('@app/Seller/Components/Base')
const SettingsProfile = () => import('@app/Seller/Settings/Profile')
const SettingsShop = () => import('@app/Seller/Settings/Shop')
// const SettingsSchedule = () => import('@app/Seller/Settings/Schedule')
const SettingsNotification = () => import('@app/Seller/Settings/Notification')

const MODEL = 'settings'

const BASE = `${MODEL}/`
// const u = url => BASE + url

const PROFILE = 'profile/'
const SHOP = 'shop/'
// const SCHEDULE = 'schedule/'
const NOTIFICATION = 'notification/'

export const SETTINGS_PREFIX = `${MODEL}:`
const p = name => SETTINGS_PREFIX + name

export const SETTINGS_BASE_NAME = p('base')
export const SETTINGS_PROFILE_NAME = p('profile')
export const SETTINGS_SHOP_NAME = p('shop')
// export const SETTINGS_SCHEDULE_NAME = p('schedule')
export const SETTINGS_NOTIFICATION_NAME = p('notofication')

export function createRoutes(options) {
  return [
    route(BASE, SettingsBase, SETTINGS_BASE_NAME, {
      meta: accessPermission(SETTINGS_TOKEN, options),
      redirect: { name: SETTINGS_SHOP_NAME },
      children: [
        route(PROFILE, SettingsProfile, SETTINGS_PROFILE_NAME, {
          meta: accessPermission(SETTINGS_TOKEN, options),
        }),
        route(SHOP, SettingsShop, SETTINGS_SHOP_NAME, {
          meta: accessPermission(SETTINGS_TOKEN, options),
        }),
        // route(SCHEDULE, SettingsSchedule, SETTINGS_SCHEDULE_NAME, {
        //   meta: accessPermission(SETTINGS_TOKEN, options),
        // }),
        route(NOTIFICATION, SettingsNotification, SETTINGS_NOTIFICATION_NAME, {
          meta: accessPermission(SETTINGS_TOKEN, options),
        }),
      ],
    }),
  ]
}
